import * as React from 'react'
import './style.scss'
import Header from '@mobileComponent/Header'
import { OpenApiDoMain } from '@src/constants'
import Bottom from '@mobileComponent/Bottom'
import Item from '@component/Item'
import AlertMessage from '@component/AlertMessage'
import axios from 'axios'

export interface IHomeStates {
  showAlert: boolean,
  itemList: any
}

export default class Home extends React.Component<any, IHomeStates> {

  constructor(props: any) {
    super(props)
    this.state = {
      showAlert: false,
      itemList: []
    }
    this.showAlertMessage = this.showAlertMessage.bind(this);
  }

  public openNewsDeatil(detailIndex: number) {
    location.href = '/newsDetailHome/' + detailIndex
  }

  public getList() {
    const that = this
    axios.get(OpenApiDoMain + '/article?pageSize=7&currentPage=1&channel=yuqinet.com&hot=&tag=')
      .then((res) => {
        that.setState({
          itemList: res.data.data
        });
      })
  }

  public componentDidMount() {
    this.getList()
    const location =this.props.location.state ? this.props.location.state.location : ''
    if (location === 'news') {
      this.scrollTo('news')
    } else if (location === 'game') {
      this.scrollTo('ourGame')
    }
  }

  public scrollTo(id: string) {
    const anchorElement = document.getElementById(id);
    if (anchorElement) {
      window.scrollTo({ top: anchorElement.offsetTop - 60, behavior: "smooth" });
    }
  }

  public getItem () {
    if (this.state.itemList.length > 0) {
      return (this.state.itemList.map((item: any, key: number)=> {
        if (key > 0) {
          return (<Item key={key} index={item.id} item={item}/>)
        } else {
          return (<div onClick={this.openNewsDeatil.bind(this, 0)} key={key}>{item.title}</div> )
        }
      }))
    }
    return
  }

  public showAlertMessage() {
    this.setState({showAlert: true});
    setTimeout(() => {
      this.setState({showAlert: false});
    }, 2000);
  }

  public openGameDeatil(detailIndex: number) {
    location.href = '/gemeDetailHome/' + detailIndex
  }

  public toNews() {
    location.href = '/mobileNews'
  }

  public toAboutUs() {
    location.href = '/mobileAboutUs'
  }

  public toJoinUs() {
    location.href = '/mobileJoinUs'
  }

  public render() {
    return (
      <div className="home-mobile">
        <Header current="mobileHome" />
        <img className="first-bg" src={require("@static/y.png")} alt="域起官网"/>
        <div id="ourGame" className="content">
          <div className="title">我们的游戏</div>
          <div className="flex">
            <img onClick={this.showAlertMessage} src={require("@static/1.png")} alt="域起官网"/>
            <img onClick={this.showAlertMessage} src={require("@static/2.png")} alt="域起官网"/>
            <img onClick={this.showAlertMessage} src={require("@static/3.png")} alt="域起官网"/>
            <img onClick={this.openGameDeatil.bind(this,  1)} src={require("@static/4.png")} alt="域起官网"/>
            <div onClick={this.showAlertMessage}>MORE+</div>
          </div>
        </div>
        <div id="news" className="content">
          <div className="title">新闻&nbsp;资讯</div>
          <div className="item-list">
            {this.getItem()}
            {
              this.state.itemList.length > 6
              ? (<div onClick={this.toNews} className="check-more">查看更多&gt;&gt;</div>)
              : ''
            }
            
          </div>
        </div>
        <div id="weAreIn" className="content">
          <div className="title">我们在域起</div>
          <div className="we-are-in-yuqi">
            <img className="width-100" src={require("@static/show1.png")} alt="域起官网"/>
            <img className="width-50" src={require("@static/gs1.png")} alt="域起官网"/>
            <div className="width-50 about-us" onClick={this.toAboutUs}> <span>关于我们</span> </div>
            <div className="width-50 join-us" onClick={this.toJoinUs}><div><span>我们正在等待你的加入</span> <span>加入我们</span></div> </div>
            <img className="width-50" src={require("@static/20190916-join1.jpg")} alt="域起官网"/>
            <img className="width-100" src={require("@static/gs3.jpg")} alt="域起官网"/>
          </div>
        </div>
        <AlertMessage message="敬请期待" show={this.state.showAlert}/>
        {/* <img className="logo-img" src={require("@static/logo2.png")} alt="域起官网"/> */}
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Mobile/Home/index.tsx